import React, { useState, useEffect } from "react";
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import useLanguage from '../../Hooks/useLanguage';
import { publicIpv4 } from "public-ip";
function ChangePassword() {
    const [oldPassword, setOldPassword] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
    const [ipAddress, setIpAddress] = useState("");
    const email = Cookies.get("email");
    useLanguage();
    const { t, i18n } = useTranslation();
    useEffect(() => {
        const fetchIp = async () => {
            try {
                const ip = await publicIpv4();
                setIpAddress(ip);
            } catch (error) {
                console.error("Lỗi khi lấy IP:", error);
            }
        };
        fetchIp();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (password !== passwordConfirm) {
            setErrorMessage("Mật khẩu và xác nhận mật khẩu không khớp.");
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/change-password`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    email: email,
                    old_password: oldPassword,
                    password: password,
                    password_confirmation: passwordConfirm,
                    ip_address: ipAddress,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                setSuccessMessage(data.message || "Đổi mật khẩu thành công!");
                setErrorMessage("");
            } else {
                setErrorMessage(data.message || "Đổi mật khẩu thất bại.");
                setSuccessMessage("");
            }
        } catch (error) {
            console.log(error);
            setErrorMessage("Có lỗi xảy ra khi kết nối đến API.");
            setSuccessMessage("");
        }
    };

    const handleReset = () => {
        setOldPassword("");
        setPassword("");
        setPasswordConfirm("");
        setErrorMessage("");
        setSuccessMessage("");
    };

    const toggleVisibilityIcon = (isVisible) => (
        <i
            className={`fa ${isVisible ? "fa-eye-slash" : "fa-eye"}`}
            aria-hidden="true"
        />
    );

    return (
        <div style={{ width: "50%", margin: "0 auto" }} id="tab_2" role="tabpanel">
            <div className="box-content-tab-default">
                <form onSubmit={handleSubmit} onReset={handleReset}>
                    <div className="form-group">
                        <label htmlFor="old_password" className="text-bold">
                            {t("Old password")} *
                        </label>
                        <div style={{ position: "relative" }}>
                            <input
                                className="form-control"
                                id="old_password"
                                type={showOldPassword ? "text" : "password"}
                                value={oldPassword}
                                onChange={(e) => setOldPassword(e.target.value)}
                                required
                            />
                            <span
                                onClick={() => setShowOldPassword(!showOldPassword)}
                                style={{ position: "absolute", right: 10, top: 10, cursor: "pointer" }}
                                aria-label="Toggle old password visibility"
                            >
                                {toggleVisibilityIcon(showOldPassword)}
                            </span>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="password" className="text-bold">
                            {t("New password")} *
                        </label>
                        <div style={{ position: "relative" }}>
                            <input
                                className="form-control"
                                id="password"
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <span
                                onClick={() => setShowPassword(!showPassword)}
                                style={{ position: "absolute", right: 10, top: 10, cursor: "pointer" }}
                                aria-label="Toggle new password visibility"
                            >
                                {toggleVisibilityIcon(showPassword)}
                            </span>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="password_confirm" className="text-bold">
                            {t("Confirm new password")} *
                        </label>
                        <div style={{ position: "relative" }}>
                            <input
                                className="form-control"
                                id="password_confirm"
                                type={showPasswordConfirm ? "text" : "password"}
                                value={passwordConfirm}
                                onChange={(e) => setPasswordConfirm(e.target.value)}
                                required
                            />
                            <span
                                onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                                style={{ position: "absolute", right: 10, top: 10, cursor: "pointer" }}
                                aria-label="Toggle confirm password visibility"
                            >
                                {toggleVisibilityIcon(showPasswordConfirm)}
                            </span>
                        </div>
                    </div>
                    {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
                    {successMessage && <div style={{ color: "green" }}>{successMessage}</div>}
                    <div className="form-group pull-right" style={{ marginTop: 15 }}>
                        <button className="btn btn-primary" type="submit">
                            <i className="fa fa-save" /> {t("Change password")}
                        </button>
                        <button className="btn bg-cancel-default" type="reset">
                            <i className="fa fa-refresh" /> {t("Refresh")}
                        </button>
                    </div>
                </form>
                <div className="clearfix" />
            </div>
        </div>
    );
}

export default ChangePassword;
